export default "__VITE_ASSET__7vfIfSF7__"